









































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import RuleExpansionPanels from './components/RuleExpansionPanels.vue';

@Component({
  components: {
    RuleExpansionPanels,
  },
})
export default class CreditRuleCreate extends Vue {
  cancel() {
    this.$router.go(-1);
  }
}
